export default {
  CREATE: `Créer un code de prime`,
  DELETE_BUTTON: {
    TITLE: `Supprimer le code de prime`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer ce code de prime ?`,
    PRIMARY_ACTION: `Supprimer le code de prime`
  },
  LIST: {
    TITLE: `Liste des codes de primes`
  },
  OVERTIME: `Temps suplémentaire`,
  EARNINGCODE: `Code de gain`,
  HASHOURMULTIPLIER: `Multiplie les heures`,
  HOURMULTIPLIER: `Facteur de multiplication`,
  HOURSAPPLIEDTO: `Appliqué à`,
  DEFAULTPREDETERMINEDHOURS: `Heures prédeterminées`,
  DEDUCTFROMREGULARHOURS: `Déduit des heures régulières`,
  COUNTASOVERTIME: `Compte comme du temps supplémentaire`,

  form: {
    CREATE: {
      TITLE: `Création d'un code de prime`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'un code de prime`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom`,
      PLACEHOLDER: `Entrez un nom pour le code de prime`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`
    },
    EARNINGCODE: {
      LABEL: `Code de gain`,
      DESCRIPTION: `Le code de gain sert à pouvoir assigner des codes de primes à des quarts de travail pour la paie et devra être défini dans votre système de paie.`,
      PLACEHOLDER: `Entrez le code de gain`
    },
    ASSIGNBASEDONATTRIBUTESENABLED: {
      LABEL: `Assigner selon les attributs`,
      DESCRIPTION: `Assigner automatiquement ce code de gain à des quarts de travail selon les attributs des employés ou des positions.`
    },
    DEDUCTFROMREGULARHOURS: {
      LABEL: `Déduire des heures régulières`,
      DESCRIPTION: `Les heures associées à ce code de gain seront soustraites du code de gain régulier (G1).`
    },
    COUNTASOVERTIME: {
      LABEL: `Compter dans le temps supplémentaire`,
      DESCRIPTION: `Les heures associées à ce code de gain seront considérées lors du calcul du temps supplémentaire par période.`
    },
    HASHOURMULTIPLIER: {
      LABEL: `Multiplie les heures`,
      DESCRIPTION: `Les heures seront mise à l'échelle de l'ordre du facteur de multiplication.`
    },
    HOURMULTIPLIER: {
      LABEL: `Facteur de multiplication`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Le multiplicateur à utiliser.`
    },
    HASPAYRATE: {
      LABEL: `A un taux horaire`,
      DESCRIPTION: `Sert à comptabiliser les primes dans les rapports de coût d'horaire.`
    },
    PAYRATETYPE: {
      LABEL: `Type de taux horaire`,
      DESCRIPTION: ``,
      REGULAR: `Régulier de l'employé`,
      OVERTIME: `Supplémentaire de l'employé`,
      CUSTOM: `Sur mesure`
    },
    PAYRATE: {
      LABEL: `Taux sur mesure`,
      DESCRIPTION: ``
    },
    HOURSAPPLIEDTO: {
      LABEL: `Heures appliquées`,
      DESCRIPTION: ``,
      UNITS: `unités`,
      OPTIONS: {
        FULL_SHIFT: {
          LABEL: `Prendre les heures du quart`,
          DESCRIPTION: `La valeur de ce code de gain sera la durée du quart en entier.`
        },
        PRE_DETERMINED: {
          LABEL: `Quantité pré-déterminée`,
          DESCRIPTION: `La valeur de ce code de gain sera d'une durée fixe.`
        },
        UNIT_BASED: {
          LABEL: `Quantité unitaire`,
          DESCRIPTION: `La valeur de ce code de gain se mesure en unités plutôt que des heures. (ex: kilométrage)`
        }
      }
    },
    ASSIGNBASEDONATTRIBUTESRULE: {
      LABEL: ``,
      DESCRIPTION: ``,
      OPTIONS: {
        userHasAttribute: {
          LABEL: `Assigner si l'employé a les attributs requis`,
          DESCRIPTION: ``
        },
        attributeRequired: {
          LABEL: `Assigner si le quart requiert des attributs`,
          DESCRIPTION: ``
        },
        attributeRequiredAndUserHasAttribute: {
          LABEL: `Assigner si il y a une correspondance entre les attributs de l'employé et les attributs requis du quart.`,
          DESCRIPTION: ``
        }
      }
    },
    ASSIGNBASEDONFOLLOWINGATTRIBUTES: {
      LABEL: '',
      DESCRIPTION: ``
    },
    DEFAULTUNITARYAMOUNT: {
      LABEL: `Quantité prédeterminée`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Valeur qu'aura le code de gain, peu importe la durée du quart. Peut être changé directement dans le quart associé.`
    },
    UNITARYAMOUNTTYPE: {
      LABEL: `Type d'unité`,
      PLACEHOLDER: `Entrez un type d'unité`,
      DESCRIPTION: `Ne sert qu'à l'affichage pour indiquer le type d'unités à utiliser (ex: km pour kilomètres).`
    },
    DEFAULTPREDETERMINEDHOURS: {
      LABEL: `Heures prédeterminées`,
      PLACEHOLDER: `Entrez un chiffre`,
      DESCRIPTION: `Nombre d'heures qui correspondera à la valeur du code de gain, peu import la durée du quart. Peut être changé directement dans le quart associé.`
    },
    ASSIGNBASEDONRANGEENABLED: {
      LABEL: 'Attribuer en fonction de plages horaires',
      DESCRIPTION: 'Attribuez automatiquement cette prime salariale aux cartes de temps dans une plage spécifiée'
    },
    NAME_REQUIRED: `Le nom est obligatoire.`,
    EARNING_CODE_REQUIRED: `Le code de gain est obligatoire.`,
    DAYS_REQUIRED: `Jour(s) est obligatoire`,
    START_TIME_REQUIRED: `Heure de début est obligatoire`,
    END_TIME_REQUIRED: `Heure de fin est obligatoire`,
    START_DAY_REQUIRED: `Jour de début est obligatoire`,
    END_DAY_REQUIRED: `Jour de fin est obligatoire`,
    ADD_RANGE: `Ajouter une autre plage`,
    FROM: `De`,
    TO: `À`,
    DAY: `Jour`,
    HOUR: `Heure`,
    SELECT: `Sélectionner`,
    ALL_DAYS: `Chaque jour`,
    MIN_ONE_RANGE: `Au moins une plage est obligatoire`,
    MIN_ONE_ATTRIBUTE: `Vous devez sélectionner au moins un attribut.`,
    SEARCH_ATTRIBUTES: `Rechercher des attributs`,
    GREATER_THAN_ZERO: `Doit être supérieur à 0`
  }
}
